export default "__VITE_ASSET__DSkNji0Q__"